var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-default',[(_vm.isLoggedIn)?_c('div',[(_vm.isMobile)?_c('PageDirectCall'):_c('Dashboard')],1):_c('div',[(_vm.isMobile)?_c('PageFreeDirectCall'):_c('PageFreeCall')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }